import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {ObservationTypeDTO} from '../models/claim-review/ObservationyTypeDTO';

@Injectable({
  providedIn: 'root'
})
export class ObservationService {
  private url = environment.baseClmUrl + '/observation';

  constructor(private httpClient: HttpClient) {
  }

  getAllObservationTypes(): Observable<ObservationTypeDTO[]> {
    return this.httpClient.get<ObservationTypeDTO[]>(this.url + '/all-types');
  }
}
